import React, {MouseEvent, useCallback, useEffect, useRef, useState} from "react"
import Modal from "./Modal";
import ModalDialogOption from "./ModalDialogOption";
import styles from '../css/Modal.module.css'
import classNames from "classnames";
import Box from "./Box";

export interface Props {
    id: string,
    show?: boolean,
    onDismiss?: (event: MouseEvent) => void,
    onConfirm?: (value: string) => void,
    isValid?: (v: string) => boolean
}

export default (props: Props) => {

    // Props

    const {id, isValid, show, onDismiss, onConfirm} = props;

    // State

    const [value, setValue] = useState("");
    const [valid, setValid] = useState(!isValid);

    // Refs

    const textarea = useRef<HTMLTextAreaElement>(null);

    // Effects

    useEffect(() => {
        if (show) {
            textarea && textarea.current && textarea.current.focus();
            setValue('');
        }
    }, [show]);

    // Callbacks

    const handleOnConfirm = useCallback(
        (e) => {
            onConfirm && value && onConfirm(value)
        },
        [onConfirm, value],
    );

    const handleOnChange = useCallback((e) => {
        if (e.target) {
            isValid && setValid(isValid(e.target.value));
            setValue(e.target.value)
        }
    }, [isValid]);

    return (
        <Modal contentClassName={styles.textModal} round id={id} show={show} center onDismiss={onDismiss}>
            <Box center className={styles.modalTextArea}>
                <textarea
                    ref={textarea}
                    value={value}
                    onChange={handleOnChange}
                    id={`${id}_textarea`}
                    onKeyDown={(e)=> {
                        if (e.keyCode === 13) {
                            e.stopPropagation();
                            e.preventDefault();
                            value && valid && handleOnConfirm(value);
                        }
                    }}
                    inputMode={"url"}
                    placeholder={'URL'}
                    cols={40}
                    rows={3}/>
            </Box>
            <Box center className={styles.modalTextAreaButtonsHolder}>
                <Box center flex>
                    <ModalDialogOption onClick={onDismiss} value={'Cancel'}/>
                </Box>
                <Box center flex className={classNames({
                    [styles.modalTextAreaButtonOK]: !!value && valid
                })}>
                    <ModalDialogOption disabled={!value || !valid} onClick={handleOnConfirm} value={'Confirm'}/>
                </Box>
            </Box>
        </Modal>
    )
}

